import { IMenu, IMenuItem } from '@makyoapp/makyo-sdk/models/AppBuilder'
import { BuilderMenu, BuilderMenuItem, ConditionValue, DefaultVariableResult } from '@makyoapp/makyo-common'

import { fromSdkActions, toSdkActions } from './BuilderActionAdapter'

export function fromSdkMenuList(menus: IMenu[]): BuilderMenu[] {
  return menus.map(fromSdkMenu)
}

export function fromSdkMenu(menu: IMenu): BuilderMenu {
  return {
    id: menu._id,
    title: menu._Title,
    items: fromSdkMenuItemList(menu._MenuItem),
    visibility: (menu._Visibility as unknown as ConditionValue) || {
      isAny: true,
      conditions: [],
    },
  }
}

export function fromSdkMenuItemList(menuItems: IMenuItem[]): BuilderMenuItem[] {
  return menuItems.map(fromSdkMenuItem)
}

export function fromSdkMenuItem(menuItem: IMenuItem): BuilderMenuItem {
  return {
    id: menuItem._id,
    icon: menuItem._Icon?.flag ? (menuItem._Icon as DefaultVariableResult) : undefined,
    title: menuItem._Title,
    badgeSize: menuItem._BadgeSize as 's',
    badgeMetadata: menuItem._BadgeMetadata as DefaultVariableResult,
    actions: menuItem._Actions ? fromSdkActions(menuItem._Actions) : [],
    visibility: (menuItem._Visibility as unknown as ConditionValue) || {
      isAny: true,
      conditions: [],
    },
  }
}

export function toSdkMenuList(menu: BuilderMenu[]): IMenu[] {
  return menu.map(toSdkMenu)
}

export function toSdkMenu(menu: BuilderMenu): IMenu {
  return {
    _MenuItem: toSdkMenuItemList(menu.items),
    _id: menu.id,
    _Title: menu.title,
    _Visibility: menu.visibility || {
      isAny: true,
      conditions: [],
    },
  }
}

export function toSdkMenuItemList(menuItems: BuilderMenuItem[]): IMenuItem[] {
  return menuItems.map(toSdkMenuItem)
}

export function toSdkMenuItem(menuItem: BuilderMenuItem): IMenuItem {
  return {
    _id: menuItem.id,
    _Title: menuItem.title,
    _Icon: menuItem.icon ?? {},
    _BadgeSize: menuItem.badgeSize,
    _BadgeMetadata: menuItem.badgeMetadata ? menuItem.badgeMetadata : {},
    _Actions: toSdkActions(menuItem.actions || []),
    _Visibility: menuItem.visibility || {
      isAny: true,
      conditions: [],
    },
  }
}
